import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ConnectionService {

  private interval;

  constructor() {
  }

  monitor(cb) {
    this.interval = setInterval(() => {
      if (navigator.onLine) {
        cb(true);
      } else {
        cb(false);
      }
    }, 1000);
  }

  close() {
    if (!isNaN(this.interval)) {
      clearInterval(this.interval);
      this.interval = undefined;
    }
  }

}

